import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { QuickStatsComponent } from '../quick-stats/quick-stats.component';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { UtilityService } from '../../../../core/utility/services/utility.service';

@Component({
	selector: 'app-sem-quick-stats-v7',
	templateUrl: './sem-quick-stats-v7.component.html',
	styleUrls: ['./sem-quick-stats-v7.component.css']
})
export class SemQuickStatsV7Component extends QuickStatsComponent implements OnInit, OnDestroy {
	@Input() iscustomendpoint: any;
	public isCutoffDate: boolean;

	constructor(protected analyticsService: AnalyticsService, protected analyticsDataModel: AnalyticsDataModel) {
		super(analyticsService, analyticsDataModel);
	}

	ngOnInit() {
		super.ngOnInit();
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	requestData() {
		super.requestData();
		this.analyticsService.checkDateRange();
		this.isCutoffDate = this.analyticsService.isCutoffDate;
	}

	processResponseData(response: any) {
		const impressions = UtilityService.isUndefinedOrNull(response[0].impressions) ? 0 : response[0].impressions;
		const clicks = UtilityService.isUndefinedOrNull(response[0].clicks) ? 0 : response[0].clicks;
		const calls = UtilityService.isUndefinedOrNull(response[0].calls) ? 0 : response[0].calls;
		const avgPosition = UtilityService.isUndefinedOrNull(response[0].avg_position)
			? 0
			: parseFloat(response[0].avg_position).toFixed(2);
		const clicksPercentage = UtilityService.isUndefinedOrNull(response[0].clicks_percent)
			? '-- '
			: parseFloat(response[0].clicks_percent).toFixed(2);

		this.quickStatsData = {
			impressions: impressions,
			clicks: clicks,
			calls: calls,
			avgPosition: avgPosition,
			clicksPercentage: clicksPercentage
		};
	}
}
